<template>
  <div class="info">
    <ul class="account-dashbord-tabs">
      <li
        class="account-dashbord-tab"
        :class="{'focus': activityCurb === tab.id}"
        @click="checkedTab(tab.id)"
        v-for="tab in tabs" :key="tab.id"
      >
        <div class="tab-word" v-if="tab.id === 0 || applyStatusInfo.status === 8">{{tab.name}}</div>
      </li>
    </ul>
    <div class="info-bord">
      <div class="nav-list" v-if="showNavList">
        <div
          :class="{ 'nav-list-focus': signCurb === item.id }"
          class="nav-last-list"
          @click="currentNavList(item.id)"
          v-for="item in bookStageList"
          :key="item.id"
        >
          <span class="nav-list-name">
            {{item.name}}
            <span class="nav-list-line"></span>
          </span>
          <!-- <span class="nav-list-icon"></span> -->
        </div>
      </div>
      <div v-if="Object.keys(groupActivityList).length">
        <div class="activity columns is-multiline">
          <ActivityList
            v-for="event in groupActivityList"
             class="is-half"
            :key="event.id"
            :event="event"
            :branches="branches"
            :pageInfo="params"
            :eventStatusKey="'events_status'"
          />
        </div>
        <MoreButton
          :loading="loading"
          :end="isEnd"
          :loadingCount="loadingCount"
          @click="getMore"
        />
      </div>
      <div class="warnTip" v-else>
        <div class="warnTip-center">
          <img class="warnTip-center-img" src="../assets/img/sad.png" />
          <div class="warnTip-center-word">暂无信息</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import { getBranchAll } from '@/util/methods'
import cache from '@/util/cache-promise'

import ActivityList from '@/components/list/ActivityList'
import MoreButton from '@/components/button/MoreButton.vue'

import { mapState } from 'vuex'

export default {
  components: {
    ActivityList,
    MoreButton
  },

  data () {
    return {
      activityCurb: 0,
      signCurb: 0,
      tabs: [
        {
          id: 0,
          name: '我报名的活动'
        },
        {
          id: 1,
          name: '我创建的活动'
        }
      ],
      // 报名阶段
      bookStageList: [
        {
          id: 0,
          name: '全部'
        },
        {
          id: 16,
          name: '报名成功'
        },
        {
          id: 4,
          name: '审核中'
        },
        {
          id: 12,
          name: '待交费'
        },
        {
          id: 8,
          name: '候补中'
        },
        {
          id: -2,
          name: '报名失败'
        }
      ],
      // 我的活动数据
      groupActivityList: [],
      // 分页数据
      params: {
        is_create: 0,
        page: 1,
        size: 6,
        status: 0
      },
      // 页码
      page: {
        pages: 0,
        total: 0
      },
      // 正在加载
      loading: false,
      // 数据是否是最后
      isEnd: false,
      // 加载的次数
      loadingCount: 0,
      branches: [],
      showNavList: true
    }
  },
  computed: {
    ...mapState([ 'isBottom', 'applyStatusInfo' ])
  },
  created () {
    // tags
    Promise.all([getBranchAll(), service.getEventTypes()])
      .then(v => {
        v[0].unshift({ id: 99999, name: '总部' })
        this.branches = v[0]
        console.log('branches', v[0])
        this.tags.push({
          type_name: '主办方',
          type_key: 'branch_id',
          tags: v[0]
        })
        this.tags.push({
          type_name: '活动类型',
          type_key: 'event_type',
          tags: v[1]
        })
        this.tags.forEach(item => {
          item.tags.unshift({ id: '', name: '全部' })
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  mounted () {
    this.getMyActivity(this.params)
  },

  methods: {
    // 活动tab栏操作
    checkedTab (id) {
      if ((id === 0 || this.applyStatusInfo.status === 8)) {
        this.activityCurb = id
        this.signCurb = 0
        this.params.is_create = id
        this.params.page = 1
        this.params.size = 10
        this.params.status = 0
        // 重置加载次数
        this.loadingCount = 0
        this.isEnd = false
        this.getMyActivity(this.params)
        this.showNavList = true
        if (id === 1) {
          this.showNavList = false
          this.params.status = 0
        }
      }
    },

    // 报名tab栏操作
    currentNavList (id) {
      this.signCurb = id
      this.params.status = id
      // 重置加载次数
      this.loadingCount = 0
      // 重置页数
      this.params.page = 1
      this.isEnd = false
      this.getMyActivity(this.params)
    },

    // 获取我的活动
    getMyActivity (params, isAppend = false) {
      // Object.keys(this.groupActivityList).length === 0
      if (this.loading || this.isEnd) return

      let paramsStatus = {
        status: this.params.status
      }

      // 防止用户多次点击发送请求
      cache.cache({
        fn: service.getMyActivity,
        parameter: paramsStatus,
        maxAge: 10000
      })
        .then(res => {
          if (res.list) {
            this.page = res.page
            this.loadingCount++
            this.loading = false
            // 如果 total 数量不能触发下拉刷新条件显示没有更多了
            if (this.page.total <= (this.params.size * this.params.page) && this.page.total >= 1) {
              this.isEnd = true
            }
            if (this.page.pages < this.page.total) {
              this.params.page++
            }
            this.groupActivityList = isAppend ? this.groupActivityList.concat(res.list) : res.list
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },

    // 手动点击获取
    getMore ({ clear }) {
      this.getMyActivity(this.params, true).then(() => {
        clear && clear()
      })
    }
  },

  watch: {
    // 判断是否滑动到底部，加载下一页数据
    isBottom (val) {
      val && !!this.loadingCount && this.loadingCount < 3 && this.getMyActivity(this.params, true)
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../../../style/bulma/app.sass';

.info {
  padding: 22px 30px 0;
}

.account-dashbord-tabs {
  border-bottom: 1px solid #d9d9d9;
  font-size: 16px;
  display: flex;
}

.account-dashbord-tab {
  padding: 0 60px 0 20px;

  &.focus
    .tab-word {
      color: $primary3;
      border-bottom: 2px solid $primary3;
    }
}

.tab-word {
  padding-bottom: 13px;
  cursor: pointer;
}

.info-bord {
  min-height: 500px;
  padding: 18px 0;
}

.nav-list {
  display: flex;
  font-size: 14px;
}

.nav-list-focus {
  font-size: 14px; font-weight: 500;
  color: #D7B375;
}

.nav-last-list {
  &:last-child .nav-list-name .nav-list-line {
    width: 0;
  }
}

.nav-list-name {
  position: relative;
  margin-right: 41px;
  cursor: pointer;
}

.nav-list-line {
  content: "";
  position: absolute; top: 2px; right: -22px;
  width: 1px; height: 14px;
  background: #E8E8E8;
}

.more-button {
  margin: 0 auto;
}

.warnTip {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
}

.warnTip-center-img {
  width: 100px
}

.warnTip-center-word {
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
}

.activity {
  margin-top: 4px;
}

::v-deep .event-info {
  border-left: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  border-right: 1px solid #E8E8E8;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

::v-deep .finish-label {
  color: #666666;
}

::v-deep .com-more-button {
  padding: 24px 0;
}

</style>
